import React, { useEffect, useRef, useContext } from "react";
import { Fade, Slide } from "react-reveal";
import "./EducationCard.scss";
import StyleContext from "../../contexts/StyleContext";

export default function EducationCard({ school }) {
  const imgRef = useRef(null);
  const scrollingListRef = useRef(null);
  const { isDark } = useContext(StyleContext);

  const GetDescBullets = ({ descBullets }) => {
    return descBullets
      ? descBullets.map((item, i) => (
          <li key={i} className="subTitle">
            {item}
          </li>
        ))
      : null;
  };

  useEffect(() => {
    const scrollingList = scrollingListRef.current;
    if (scrollingList) {
      const listItems = scrollingList.innerHTML;
      scrollingList.innerHTML += listItems; // Duplicate the list items
      // Set the correct width for the seamless effect
      scrollingList.style.width = `${scrollingList.scrollWidth / 2}px`;
    }
  }, []);

  if (!school.logo)
    console.error(`Image of ${school.name} is missing in education section`);

  const scrollingListClassName = school.courses.length > 10 ? "scrolling-list-2" : "scrolling-list";

  return (
    <div>
      <Fade left duration={1000}>
        <div className="education-card">
          {school.logo && (
            <div className="education-card-left">
              <img
                crossOrigin={"anonymous"}
                ref={imgRef}
                className="education-roundedimg"
                src={school.logo}
                alt={school.schoolName}
              />
            </div>
          )}
          <div className="education-card-right">
            <h5 className="education-text-school">{school.schoolName}</h5>

            <div className="education-text-details">
              <h5
                className={
                  isDark
                    ? "dark-mode education-text-subHeader"
                    : "education-text-subHeader"
                }
              >
                {school.subHeader}
              </h5>
              <p
                className={`${
                  isDark ? "dark-mode" : ""
                } education-text-duration`}
              >
                {school.duration}
              </p>
              <p className="education-text-desc">{school.desc}</p>
              <div className="education-text-bullets">
                <ul>
                  <GetDescBullets descBullets={school.descBullets} />
                </ul>
              </div>
              <div>
                <h3 style={{ margin: 0 }}>Courses</h3>
                <div className="scrolling-wrapper">
                  <div className={scrollingListClassName} ref={scrollingListRef}>
                    {school.courses.map((course, index) => (
                      <p className="education-text-desc" key={index}>
                        {course}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fade>

      <Slide left duration={2000}>
        <div className="education-card-border"></div>
      </Slide>
    </div>
  );
}
